define(function (require) {
    "use strict";

    var Backbone = require('backbone');

    var DropdownMenuItemModel = Backbone.Model.extend({
        defaults : {
            id : 0,
            actionName : "",
            title: "", //tooltip
            align: "", //tooltip alignment
            enabled : true,
            icon: ""
        }
    });

    return DropdownMenuItemModel;
});